import { FilterValues, IActiveFilter, ISort } from '../../base';

export enum TableFormValues {
    search = 'search',
    tableId = 'tableId',
    filters = 'filters',
    sort = 'sort',
    selectedRows = 'selectedRows',
    toggles = 'toggles',
}

export interface ITableForm {
    [TableFormValues.search]: string;
    [TableFormValues.tableId]: string;
    [TableFormValues.filters]: Array<IActiveFilter> | FilterValues;
    [TableFormValues.sort]: ISort;
    [TableFormValues.selectedRows]: Record<string, boolean>;
    [TableFormValues.toggles]: Record<string, boolean>;
}

export interface IServerPaginatedResponse {
    current_page: number;
    next: string;
    previous: string;
    results: Array<Record<string, unknown>>;
    total_count: number;
    total_pages: number;
}
